import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ContainerHorizontal } from "components";
import ContentPanel from "../components/ContentPanel";
import TopBar from "./TopBar";
import cls from "./newassessment.module.scss";
import { create as createCustomerProfileAction } from "@redux/customerProfile/actions";
import { update as updateCustomreProfileAction } from "@redux/customerProfile/actions";
import { CustomerProfileConfig, useRedux } from "@redux";

//Routes
import CustomerInfo from "./CustomerInfo";
import OwnerShip from "./OwnershipModel";
import FacilityInfo from "./FacilityInfo";
import Specialties from "./Specialties";
import Communications from "./Communications";
import Acutecare from "./Acutecare";

import validateCustomerInfo from "./CustomerInfo/validateCustomerInfo";
import validateOwnership from "./OwnershipModel/validateOwnershipModel";
import validateSpecialty from "./Specialties/validateSpecialty";
import validateFacility from "./FacilityInfo/validateFacilityModel";

//Redux
import { AppState } from "@redux";
import * as appActions from "@redux/app/actions";
import { connect, useSelector } from "react-redux";

//hook
import { useIsOpenControls } from "hooks";

//Modal
import AssessmentSavedModal from "./Modal/assessmentSaved";
import AssessmentDeleteModal from "./Modal/assessmentDeleted";
import AssessmentCompleteModal from "./Modal/assessmentComplete";
import AssessmentSaveExit from "./Modal/assessmentSaveExit";
import AssessmentFinal from "./Modal/assessmentFinal";
import { Formik } from "formik";
import { ASSESSMENT_TYPE } from "types";

export const initialValues: CustomerProfileConfig = {
  version: 1,
  isManual: false,
  account_name: "",
  city: "",
  state: "",
  streetAddress: "",
  asc: "",
  date_opend: "",
  hired: "",
  started: "",
  healthcare_partner: "",
  asc_management_partner: "",
  hired_medical_equipment_planner: "",
  performed_feasibility_study: "",
  has_con_laws: "",
  submitted_con_application: "",
  has_slated_opening_date: "",
  has_software_platform: "",
  owner_ship: [
    { label: "Surgeon", value: 0 },
    { label: "Hospital/IDN", value: 0 },
    { label: "Management company", value: 0 },
    { label: "Private equity", value: 0 },
    {
      label: "Additional physicians (non-surgeon, anesthesia, etc.)",
      value: 0,
    },
  ],
  owner_ship_addions: [],
  owner_ship_total: 0,
  owner_ship_hospital: "",
  owner_ship_company: "",
  facility_new: [
    {
      label: "HOW MANY TOTAL OPERATING ROOMS WILL YOUR FACILITY HAVE?",
      value: "",
    },
    {
      label: "HOW MANY TOTAL PROCEDURE ROOMS WILL YOUR FACILITY HAVE?",
      value: "",
    },
    {
      label: "HOW MANY PRE-OP PATIENT BAYS WILL YOUR FACILITY HAVE?",
      value: "",
    },
    {
      label: "HOW MANY POST-OP PATIENT BAYS WILL YOUR FACILITY HAVE?",
      value: "",
    },
    {
      label: "How many lobbies/waiting rooms will you have?",
      value: "",
    },
    {
      label: "Will your ASC have capabilities for overnight stays?",
      value: "",
    },
    {
      label:
        "How many bays/rooms will you dedicate for overnight capabilities?",
      value: "",
    },
  ],
  facility_existing: [
    {
      label: "How many total operating rooms does your facility have?",
      value: "",
    },
    {
      label:
        "Do any of your current operating rooms need to be updated with new tables, lights, ceiling mounts, etc.?",
      value: "",
    },
    {
      label: "If yes, how many? (free form number)",
      value: "",
    },
    {
      label: "How many total procedure rooms does your facility have?",
      value: "",
    },
    {
      label:
        "How many total pre-op and post-op patient bays does your facility have?",
      value: "",
    },
  ],
  facility_expanding: [
    {
      label:
        "How many total operating rooms does your facility currently have already?",
      value: "",
    },
    {
      label: "How many are you adding as part of expansion project?",
      value: "",
    },
    {
      label: "How many of the existing OR's need to be updated?",
      value: "",
    },
    {
      label: "How many procedure rooms does your facility currently have?",
      value: "",
    },
    {
      label: "How many are being added as part the expansion project?",
      value: "",
    },
    {
      label:
        "How many pre-op patient bays does your facility currently have? ",
      value: "",
    },
    {
      label:
        "How many post-op patient bays does your facility currently have? ",
      value: "",
    },
    {
      label: "How many are being added as part of expansion project?",
      value: "",
    },
    {
      label: "How many lobbies/waiting rooms do you currently have?",
      value: "",
    },
    {
      label: "How many are being added as part of expansion project?",
      value: "",
    },

    {
      label:
        "Does your facility currently have capabilities for overnight stays?",
      value: "",
    },
    {
      label:
        "How many bays/rooms are currently dedicated for overnight capabilities?",
      value: "",
    },
    {
      label:
        "How many bays/rooms are you adding for overnight capabilities as part of your expansion project?",
      value: "",
    },
  ],
  facility_all_option: [
    {
      label: "Have you settled on a vendor for sterilization yet?",
      value: "",
    },
    {
      label:
        "Will you (or do you) have low-temp or high-temp methods for sterilization?",
      value: "",
    },
  ],
  facility_note: "",
  specialties: [
    {
      label: "Sports Medicine",
      value: 0,//0
      estimatedPerMonth: 0,
      image: "sportsMedicine.png",
    },
    {
      label: "Joint Replacement (Hip and Knee)",
      value: 0,//1
      estimatedPerMonth: 0,
      image: "hipKnee.png",
    },
    {
      label: "Joint Replacement (Shoulder)",
      value: 0,//2
      estimatedPerMonth: 0,
      image: "shoulder.png",
    },
    { label: "Spine", value: 0, estimatedPerMonth: 0, image: "spine.png" },//3
    {
      label: "Foot & Ankle",
      value: 0,//4
      estimatedPerMonth: 0,
      image: "footAnkle.png",
    },
    {
      label: "Hand & Wrist",
      value: 0,//5
      estimatedPerMonth: 0,
      image: "handWrist.png",
    },
    {
      label: "Pain Management/RF ablation",
      value: 0,
      estimatedPerMonth: 0,
      image: "painManagement.png",
    },
    {
      label: "Trauma & Extremities",
      value: 0,
      isRemoved: true,
      estimatedPerMonth: 0,
      image: "generalSurgery.png",
    },
    { label: "ENT", value: 0, estimatedPerMonth: 0, image: "ENT.png" },
    { label: "Breast", value: 0, isRemoved: true, estimatedPerMonth: 0 },
    {
      label: "General surgery",
      value: 0,
      estimatedPerMonth: 0,
      image: "generalSurgery.png",
    },
    { label: "GYN", value: 0, isRemoved: true, estimatedPerMonth: 0 },
    {
      label: "Ocular surgery (eyes)",
      value: 0,
      isRemoved: true,
      estimatedPerMonth: 0,
    },
  ],
  smsub: {
    smdrop: ["", "0", "1"],
    smary: [
      { label: "Hip", value: 10 },
      { label: "Knee", value: 35 },
      { label: "Shoulder", value: 35 },
      { label: "F&A", value: 20 },
      { label: "Other:", value: 0 },
      { label: "What % of knees are ACLs?", value: 35 },
    ],
  }, // subview for sport medicine
  jpsub: [
    //{ label: "Total knee", value: false },
    { label: "Total knee/Partial knee", value: false },
    { label: "Total hip", value: false },
  ],
  jpsub1: "", // Total Joint OR
  jpsub2: "",
  sp1: "", //items={[{ label: "Imaging with navigation", value: 0 },{ label: "Imaging only", value: 1 },{ label: "No imaging needed", value: 2 },]}
  sp2: "", //items={[{ label: "2D navigation", value: 0 },{ label: "3D navigation", value: 1 },]}
  entNav: "No",
  eyeNewfacility: {
    label: "How many eye surgeons will be operating at the same time?",
    value: "",
  },
  eyeExpandingfacility: {
    label:
      "Are you adding any eye surgeons that will require new eye stretchers?",
    value: "",
  },
  specialties_addtions: [],
  communication1: {
    label: "How many Standard ORs?",
    value: 0,
  },
  /*  communication2: {
     label: "How many Cart-Based MIS ORs?",
     value: 0,
   }, */
  communication3: {
    label: "How many iSuite ORs?",
    value: 0,
  },
  acutecare1: {
    label: "How many Prime 5th Comfort stretchers does your facility need?",
    value: 0,
  },
  acutecare2: {
    label:
      "How many Prime 5th ComfortGel stretchers does your facility need?",
    value: 0,
  },
  acutecare3: {
    label:
      "How many Prime 5th Wheel Electric stretchers does your facility need?",
    value: 0,
  },
  standardORs: [
    {
      partNumber: "",
      product: "Accend Dual Light Suspension",
      category: "Accend Surgical light",
      qty: 0,
      ASCCode: "CommC01",
      bu: "Communications",
      summaryLabel: "Surgical light",
    },
    {
      partNumber: "",
      product: "Operon D770",
      category: "Surgical table",
      qty: 0,
      ASCCode: "CommC01",
      bu: "Communications",
      summaryLabel: "Surgical table",
    },
    /*   {
        partNumber: "CY 1008104",
        product: "Wall Control",
        category: "Touch wall control",
        qty: 0,
        ASCCode: "CommC01",
        bu: "Communications",
        summaryLabel: "Surgical light wall control panel",
      }, */
  ],
  standardORsAddons: [
    /*  {
       partNumber: "TBD",
       product: "Sterile Control Plus",
       category: "operates light through sterile light handle",
       qty: 0,
       ASCCode: "CommC07",
       bu: "Communications",
     }, */
    {
      partNumber: "",
      product: "Hospital Status - Room Monitoring Systems",
      category: "Internet based room status viewing application",
      qty: 0,
      ASCCode: "CommC08",
      bu: "Communications",
    },

    /*  {
       partNumber: "P36000",
       product: "StrykeCam ILC",
       category: "in light camera - overhead view of surgery",
       qty: 0,
       ASCCode: "CommC09",
       bu: "Communications",
     },
     {
       partNumber: "TBD",
       product: "SLD (single large diffuser)",
       category: "HVAC/sterile air onto patient**",
       qty: 0,
       bu: "Communications",
       ASCCode: "QUOTE VIA OR RENO",
     }, */
    {
      partNumber: "",
      product: "Modular Ceiling",
      category: "HVAC/sterile air onto patient",
      qty: 0,
      ASCCode: "CommC11",
      bu: "Communications",
    },
  ],
  cartbasedORs: [
  ],
  cartbasedORsAddons: [
  ],
  isuitORs: [
    {
      partNumber: "",
      product: "Accend/FP Combo",
      category: 'Surgical light/32" display mount',
      qty: 0,
      ASCCode: "CommC03",
      bu: "Communications",
      summaryLabel: 'Surgical light / 32" display mount',
      summaryLabel1: '32" display mount',
    },
    {
      partNumber: "",
      product: "Operon D830",
      category: "Surgical table",
      qty: 0,
      ASCCode: "CommC03",
      bu: "Communications",
      summaryLabel: "Surgical table",
    },
    {
      partNumber: "SPS-3-T",
      product: "S-Series, Fixed 3 Row",
      category: "Equipment boom",
      qty: 0,
      ASCCode: "CommC03",
      bu: "Communications",
      summaryLabel: "Equipment boom - Not always necessary",
    },
    {
      partNumber: "",
      product: "COR LITE",
      category: "OR Integration system",
      qty: 0,
      ASCCode: "CommC03",
      bu: "Communications",
      summaryLabel: "OR Integration system - COR Lite",
    },
    {
      partNumber: "",
      product: "Hub Base System",
      category: "OR Integration system control",
      qty: 0,
      ASCCode: "CommC03",
      bu: "Communications",
      summaryLabel: "Connected OR hub",
    },
  ],
  isuitORsAddons: [
    {
      partNumber: "",
      product: "Hospital Status - Room Monitoring Systems",
      category: "Internet based room status viewing application",
      qty: 0,
      ASCCode: "CommC08",
      bu: "Communications",
    },
    {
      partNumber: "",
      product: "Modular Ceiling",
      category: "HVAC/sterile air onto patient",
      qty: 0,
      ASCCode: "CommC04",
      bu: "Communications",
    },
    {
      partNumber: "",
      product: "DataMediatOR - EMR connectivity (Variable number of Rooms)",
      category: "EPIC & Cerner (EMR) interface connectivity",
      qty: 0,
      ASCCode: "CommC04",
      bu: "Communications",
    },
    {
      partNumber: "",
      product: "Studio3 - Media Asset Management (Variable number of Rooms)",
      category: "Dropbox and iPad for surgeon media",
      qty: 0,
      ASCCode: "CommC05",
      bu: "Communications",
    },

    {
      partNumber: "",
      product: "Cisco Codec",
      category: "Live video calling",
      qty: 0,
      ASCCode: "CommC06",
      bu: "Communications",
    },
  ],
  makoSmartRobotics: [
    {
      partNumber: "",
      product: "Mako SmartRobotics Knee application system",
      category: "Total Knee/Partial Knee",
      qty: 0,
      ASCCode: "ON MAKO SCREEN",
      bu: "",
      summaryLabel: "Mako SmartRobotics Knee application system",
    },
    {
      partNumber: "",
      product: "Mako SmartRobotics Hip application system",
      category: "Total Hip",
      qty: 0,
      ASCCode: "ON MAKO SCREEN",
      bu: "",
      summaryLabel: "Mako SmartRobotics Hip application system",
    },
  ],
  wasteManagements: [
    {
      partNumber: "0703-001-000",
      product: "120V Neptune 3 Rover",
      category: "Waste Management rover",
      qty: 0,
      ASCCode: "SurgTechC01",
      bu: "Surgical Technologies",
      summaryLabel: "Neptune rover",
    },

    {
      partNumber: "0702-014-000",
      product: "Neptune 2 Docking Station",
      category: "Waste Management rover docking station",
      qty: 0,
      ASCCode: "SurgTechC01",
      bu: "Surgical Technologies",
      summaryLabel: "Neptune docking station",
    },

    {
      partNumber: "0085-002-001",
      product: "PharmaLock O.R.",
      category: "Controlled substance waste management",
      qty: 0,
      ASCCode: "SurgTechC04",
      bu: "Surgical Technologies",
      summaryLabel: "PharmaLock controlled substance waste management system",
    },
  ],

  wasteManagementAddons: [
    {
      partNumber: "0711-001-000",
      product: "Neptune S Rover ",
      category: "Low-fluid Waste Management rover",
      qty: 0,
      ASCCode: "",
      bu: "Surgical Technologies",
    },
  ],
  wasteManagementsSwap: [
    {
      partNumber: "0703-001-000U",
      product: "Pre-owned 120V Neptune 3 Rover",
      category: "Waste Management rover",
      qty: 0,
      ASCCode: "SurgTechC02",
      bu: "Surgical Technologies",
      isRemoved: true,
    },
  ],
  saftySpongeSystem: [
    {
      partNumber: "0894-100-100",
      product: "SC+ Stand Kit: Sponge Counting",
      category: "SurgiCount+ Safety-Sponge System",
      qty: 0,
      ASCCode: "",
      bu: "",
      summaryLabel: "SurgiCount+ Safety-Sponge System",
    },
    {
      partNumber: "0894-002-001",
      product: "SURGICOUNT+ STAND 3.0",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0694-002-003",
      product: "SURGICOUNT+ CRADLE WALL MOUNT",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0694-002-002",
      product: "SURGICOUNT+ CRADLE",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },

    {
      partNumber: "0694-002-005",
      product: "SURGICOUNT+ READER",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0894-001-000",
      product: "Surgical Tablet 3.0",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0894-001-001",
      product: "Sugical Tablet 3.0 Case",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0894-001-002",
      product: "Surgical Tablet 3.0 Mount ",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },

    {
      partNumber: "0894-001-006",
      product: "SurgiCount+ Power Distribution",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },



  ],

  saftySpongeSystemAddons: [
    {
      partNumber: "0694-002-002",
      product: "SurgiCount+ Safety-Sponge System (Generation 2)",
      category: "SurgiCount+ Safety-Sponge System",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0894-000-003 ",
      product: "SC+ Sponge Counting Software ",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0694-002-090 ",
      product: "SurgiCount+ Application ",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
    {
      partNumber: "0794-001-095 ",
      product: "SurgiCount EMR Software Licence ",
      category: "",
      qty: 0,
      ASCCode: "",
      bu: "",
    },
  ],

  safeAir: [
    {
      partNumber: "0703-045-000",
      product: "Compact Smoke Evacuator, stand alone",
      category: "SafeAir",
      qty: 0,
      ASCCode: "",
      bu: "Surgical Technologies",
      summaryLabel: "Compact Smoke Evacuator, stand alone",
    },
    {
      partNumber: "0703-045-001",
      product: "Foot pedal, Compact Smoke Evacuator",
      category: "SafeAir",
      qty: 0,
      ASCCode: "",
      bu: "Surgical Technologies",
      summaryLabel: "Foot pedal, Compact Smoke Evacuator",
    },
  ],

  generalStretchers: [

    {
      partNumber: "1105-000-030",
      product:
        "Better Model (Prime 5th Wheel - ComfortGel): Basic model with 5th Wheel, ComfortGel, Push Handles, IV Pole, Dual Latch, No Pump Rack, 2 Sided Hydraulic, 4 sided Brake Steer, Lift Assist, Scale",
      category: "General Stretcher",
      qty: 0,
      ASCCode: "AcuteC12",
      bu: "Acute Care",
      summaryLabel: "Prime 5th wheel - ComfortGel",
    },
  ],
  generalStretchersAddons: [
    {
      partNumber: "1105-045-700",
      product: "Serving Tray",
      category: "Serving/Instrument Tray",
      qty: 0,
      ASCCode: "AcuteC14",
      bu: "Acute Care",
    },
    {
      partNumber: "1105-045-400",
      product: "Footboard Extender/Defib Tray",
      category: "Stretcher Extender",
      qty: 0,
      ASCCode: "AcuteC14",
      bu: "Acute Care",
    },
  ],
  patienWarning: {
    partNumber: "8001-000-001",
    product: "Altrix",
    category: "Patient Temperature Management System",
    qty: 0,
    ASCCode: "",
    bu: "",
    summaryLabel: "Altrix - Patient Temperature Management System",
  },
  transportChairs: {
    partNumber: "1460-000-000",
    product: "Prime TC",
    category: "Transport Chairs",
    qty: 0,
    ASCCode: "AcuteC02",
    bu: "Acute Care",
    summaryLabel: "Prime TC transport chair",
  },
  surgeonStools: {
    partNumber: "0830-000-000",
    product: "Surgistool",
    category: "Surgeon Stools",
    qty: 0,
    ASCCode: "AcuteC03",
    bu: "Acute Care",
    summaryLabel: "Surgistool chair",
  },
  patientBayFurniture: [
    {
      partNumber: "3150000100",
      product: "Single TopOver Bed Table",
      category: "Patient Bay Furniture",
      qty: 0,
      ASCCode: "AcuteC09",
      bu: "Acute Care",
      summaryLabel: "Single TopOver Bed Table - Patient bay",
    },
    {
      partNumber: "3500-000-501",
      product: "Unity Patient Room Seating Chairs",
      category: "Patient Bay Furniture",
      qty: 0,
      ASCCode: "AcuteC06",
      bu: "Acute Care",
      summaryLabel: "Patient room seating chair - Patient bay",
    },
  ],
  overnightBayRoomFurniture: [
    {
      partNumber: "3500-000-691",
      product: "Unity Chaise Lounge Sleeper",
      category: "Overnight Bay/Room Furniture",
      qty: 0,
      ASCCode: "AcuteC08",
      bu: "Acute Care",
      summaryLabel: "Recliner bed - Overnight Bay/Room Furniture",
    },
    {
      partNumber: "3500000710",
      product: "Treatment Recliner Standard",
      category: "Overnight Bay/Room Furniture",
      qty: 0,
      ASCCode: "AcuteC10",
      bu: "Acute Care",
      summaryLabel: "Treatment recliner - Overnight Bay/Room Furniture",
    },
  ],
  lobbyRoomFurniture: [
    {
      partNumber: "3500-000-501",
      product: "Unity Side Seating Chairs",
      category: "Lobby/Waiting Room Furniture",
      qty: 0,
      ASCCode: "AcuteC05",
      bu: "Acute Care",
      summaryLabel: "Lobby seating chair - Lobby/waiting room",
    },
    {
      partNumber: "3500-000-509",
      product: "Unity Bariatric Side Seating Chairs",
      category: "Lobby/Waiting Room Furniture",
      qty: 0,
      ASCCode: "AcuteC07",
      bu: "Acute Care",
      summaryLabel: "Bariatric patient chair - Lobby/waiting room",
    },
  ],
  spineNavigations: [
    {
      partNumber: "7800000000",
      product: "Ziehm RFD 3D standard",
      category: "C-Arm",
      qty: 0,
      bu: "Spine",
      ASCCode: "SpineC01",
      summaryLabel: "Ziehm Vision RFD 3D C-Arm (Standard)",
    },
    {
      partNumber: "7800510000",
      product: "Expanded field of view",
      category: "C-Arm",
      qty: 0,
      bu: "Spine",
      ASCCode: "SpineC01",
      summaryLabel: "Ziehm Vision RFD 3D C-Arm (Expanded View)",
    },
    {
      partNumber: "8900-100-000",
      product: "Q Guidance System",
      category: "Platform",
      qty: 0,
      bu: "",
      ASCCode: "",
      summaryLabel: "Spine Q Guidane System",
    },
    {
      partNumber: "6002-810-000",
      product: "Spine Guidance 5 Software",
      category: "Software",
      qty: 0,
      bu: "",
      ASCCode: "",
    },
    {
      partNumber: "6002-810-020",
      product: "Spine Guidance 5 Ziehm C-arm",
      category: "License",
      qty: 0,
      bu: "",
      ASCCode: "",
    },
    {
      partNumber: "MobiCT-32",
      product: "Airo System",
      category: "Imaging",
      qty: 0,
      bu: "",
      ASCCode: "",
      summaryLabel: "Airo TruCT Imaging",
    },
    {
      partNumber: "6000-670-000",
      product: "Cranial Guidance Software",
      category: "Software",
      qty: 0,
      bu: "",
      ASCCode: "",
    },
    {
      partNumber: "TBD",
      product: "Intruments and Trackers",
      category: "Instrumentation",
      qty: 0,
      bu: "",
      ASCCode: "",
    },
    {
      partNumber: "6002-390-000",
      product: "SpineMask Tracker",
      category: "Spine Nav",
      qty: 0,
      bu: "",
      ASCCode: "",
    },

  ],
  spineInstrumentation: [
    {
      partNumber: "TBD",
      product: "Spine Instrumentation Package",
      category: "Spine Instrumentation",
      qty: 1,
      bu: "Spine",
      ASCCode: "SpineC05",
      summaryLabel: "Spine Instrumentation Package",
    }
  ],
  crashcartsDefibrillators: [
    {
      partNumber: "99512-001262",
      product: "LIFEPAK CR2 Semi-automatic, WIFI,English, Handle",
      category: "AED",
      qty: 2,
      bu: "Emergency Care",
      ASCCode: "ECareC01",
      summaryLabel: "LIFEPAK CR2 AED",
    },
    {
      partNumber: "11998-000321",
      product: "Ambu® Res-Cue Mask® First Responder Kit",
      category: "AED accessories",
      qty: 2,
      bu: "Emergency Care",
      ASCCode: "ECareC01",
    },
    {
      partNumber: "11220-000093",
      product: "LIFEPAK CR2 AED Surface Mount Cabinet with Alarm",
      category: "AED accessories",
      qty: 2,
      bu: "Emergency Care",
      ASCCode: "ECareC01",
    },
    {
      partNumber: "70335-000046",
      product: "LIFEPAK 35 (different configurations available) - Manual & AED, Trending, Noninvasive Pacing, Synchronized cardioversion, ECG monitoring, Non - Invasive Blood Pressure Monitoring and Invasive Pressure Monitoring. - Included at N / C in ShipKkit: QUIK - COMBO Therapy Cable -3 - Lead ECG cable - NIBP Cuffs - 1 Test Load per device",
      category: "Crash cart/defibrillator",
      qty: 0,
      bu: "Emergency Care",
      ASCCode: "ECareC02",
      summaryLabel: "LIFEPAK 35 Crash cart/Defibrillator",
    },
  ],
  emergencyPreparedness: [
    {
      partNumber: "99576-000063",
      product: "LUCAS 3, version 3.1 Chest Compression System includes at N/C: Hard Shell Case, Slime Back Plate, (2) Patient Straps, (1) Stabilization Strap, Suction Cups, (1) Rechargeable Battery and Inctructions for use",
      category: "Mechanical CPR device",
      qty: 0,
      bu: "Medical",
      ASCCode: "ECare03",
      summaryLabel: "LUCAS 3 Chest Compression System"
    },
    {
      partNumber: "6254-000-000",
      product: "Evacuation Chair - 1 per floor per stairwell",
      category: "Emergency Preparedness",
      qty: 0,
      bu: "Medical",
      ASCCode: "ECareC03",
      summaryLabel: "Evacuation chair",
    },
    {
      partNumber: "6254-050-000",
      product: "Wall Bracket - 1 per chair",
      category: "Emergency Preparedness",
      qty: 0,
      bu: "Medical",
      ASCCode: "ECareC03",
    },
    {
      partNumber: "6254-055-000",
      product: "Chair Cover - 1 per wall bracket",
      category: "Emergency Preparedness",
      qty: 0,
      bu: "Medical",
      ASCCode: "ECareC03",
    },
  ],
  vocera: [
    {
      partNumber: "N/A",
      product: "The Vocera Ease application provides healthcare facilities the means to communicate in a convenient and secure way. The Ease application provides an important bridge between the care team and family by sending one-way HIPAA compliant messages, photos and videos. It integrates into workflow, reduces calls and makes it easy for loved ones to provide feedback.",
      category: "Vocera Ease Application",
      qty: 1,
      bu: "",
      ASCCode: "",
      summaryLabel: "Vocera Ease Application",
    },
    {
      partNumber: "N/A",
      product: "Operate the lightweight, wearable Minibadge using only your voice, as a smartphone companion or by itself. Make and receive calls and listen and respond to messages and alarm notifications hands-free. Improve staff and patient safety with a hands-free experience, even under restrictive PPE.",
      category: "Vocera Ease Minibadge",
      qty: 1,
      bu: "",
      ASCCode: "",
      summaryLabel: "Vocera Minibadge",
    },
  ],
  powerTools: [
    {//0
      partNumber: "9205-000-000",
      product: "Dual trigger rotary",
      summaryLabel: "System 9 large bone power tools",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//12
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//1
      partNumber: "9208-000-000",
      product: "Sagittal saw",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//13
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//2
      partNumber: "8203-133-000",
      product: `1/4"(6.4mm) locking keyless chuck`,
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//14
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//3
      partNumber: "6203-110-000",
      product: "Small AO quick connect",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//15
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//4
      partNumber: "6203-135-000",
      product: "Hudson modified trinkle",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//16
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//5
      partNumber: "8203-026-000",
      product: "Dual trigger wire collet (.7-2.0mm)",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//17
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//6
      partNumber: "8203-126-000",
      product: "Dual trigger pin collet (2.0-3.2mm)",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//18
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//7
      partNumber: "9215-000-000",
      product: "System 9 large battery pack",//19
      summaryLabel: "System 9 large battery pack",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//8
      partNumber: "9110-120-000",
      product: "System 9 battery charger",//20
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//9
      partNumber: "7102-553-030",
      product: "Lid",//21
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//10
      partNumber: "7102-662-020",
      product: "Solid container bottom",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//22
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//11
      partNumber: "7102-452-010",
      product: "2 HP insert tray",
      category: "Total Joint Power Tools (System 9 set)",
      qty: 0,//23
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    //24
    {//12
      partNumber: "7400-004-000",
      product: "TPX cord",
      category: "Extremity power tools (TPX set)",
      qty: 0,//24
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
      summaryLabel: "TPX small bone power tools",
    },
    {//13
      partNumber: "7400-034-000",
      product: "TPX sag saw",
      category: "Extremity power tools (TPX set)",
      qty: 0,//25
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//14
      partNumber: "7400-037-000",
      product: "TPX recip saw",
      category: "Extremity power tools (TPX set)",
      qty: 0,//26
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//15
      partNumber: "7400-099-000",
      product: "TPX universal driver",
      category: "Extremity power tools (TPX set)",
      qty: 0,//27
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//16
      partNumber: "4500-125-000",
      product: "Universal collet",
      category: "Extremity power tools (TPX set)",
      qty: 0,//28
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//17
      partNumber: "4100-110-000",
      product: "Small AO",
      category: "Extremity power tools (TPX set)",
      qty: 0,//29
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//18
      partNumber: "4100-131-000",
      product: '1/4" Jacobs chuck w/ key',
      category: "Extremity power tools (TPX set)",
      qty: 0,//30
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//19
      partNumber: "4100-132-000",
      product: '5/32" Jacobs chuck w/ key',
      category: "Extremity power tools (TPX set)",
      qty: 0,//31
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//20
      partNumber: "7400-009-000",
      product: "TPX handswitch",
      category: "Extremity power tools (TPX set)",
      qty: 0,//32
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//21
      partNumber: "5400-052-000US",
      product: "CORE 2 console",
      category: "Extremity power tools (TPX set)",
      qty: 0,//33
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//22
      partNumber: "6400-277-010",
      product: "Small bone insert tray",
      category: "Extremity power tools (TPX set)",
      qty: 0,//34
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//23
      partNumber: "7102-550-030",
      product: "Lid",
      category: "Extremity power tools (TPX set)",
      qty: 0,//35
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//24
      partNumber: "7102-652-020",
      product: "Solid bottom container",
      category: "Extremity power tools (TPX set)",
      qty: 0,//36
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC02",
    },
    {//25
      partNumber: "4605-000-000",
      product: "System 9 Cordless Driver",
      category: "Sports Medicine power tools (cordless driver set)",
      summaryLabel: "System 9 cordless driver medium bone power tools",
      qty: 0,//48
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
      //summaryLabel: "System 9 cordless driver Power Tools set"
    },

    {//26
      partNumber: "4607-000-000",
      product: "System 9 CD NXT",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//48
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
      //summaryLabel: "System 9 cordless driver Power Tools set"
    },

    {//26
      partNumber: "4100-400-000",
      product: "Sagittal Saw Attachment",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//49
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//27
      partNumber: "4500-125-000",
      product: "Universal Collet (non-adj)",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//50
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//28
      partNumber: "4505-133-000",
      product: `1/4"(6.4mm) locking keyless chuck`,
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//51
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//29
      partNumber: "4100-135-000",
      product: "Hudson modified trinkle drill",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//52
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//30
      partNumber: "4405-231-000",
      product: `POWEReam 1/4" chuck with key`,
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//53
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//31
      partNumber: "9212-000-000",
      product: "System 9 small battery pack",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//54
      summaryLabel: "System 9 small battery pack",
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//32
      partNumber: "9110-120-000",
      product: "System 9 battery charger",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//55
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//33
      partNumber: "7102-553-030",
      product: "Lid",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//56
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//34
      partNumber: "7102-653-020",
      product: "Solid container",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//57
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    {//35
      partNumber: "4405-653-000",
      product: "1 HP inset tray",
      category: "Sports Medicine power tools (cordless driver set)",
      qty: 0,//58
      bu: "Orthopaedic Instruments",
      ASCCode: "ECareC03",
    },
    //59
    {//36
      partNumber: "5407-300-000",
      product: "Pi Drive Plus",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//59
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
      summaryLabel: "Pi Drive Plus Spine power tools",
    },
    {//37
      partNumber: "5407-120-470",
      product: "Elite 12 cm Straight Attachments",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//60
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//38
      partNumber: "5407-120-472",
      product: "Elite 12 cm Angled Attachment",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//61
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//39
      partNumber: "5407-120-480",
      product: "Elite 14cm Straight Attachment",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//62
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//40
      partNumber: "5407-120-482",
      product: "Elite 14cm Angled Attachment",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//63
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//41
      partNumber: "5407-120-070",
      product: "HD 14cm Straight Attachment",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//64
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//42
      partNumber: "5407-120-072",
      product: "HD 14cm Angled Attachment",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//65
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//43
      partNumber: "5400-700-000",
      product: "Bone Mill",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//66
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//44
      partNumber: "5402-007-000",
      product: "CORE FS",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//67
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
    {//45
      partNumber: "5400-052-000US",
      product: "CORE 2 Console",
      category: "Spine power tools (Pi Drive set)",
      qty: 0,//68
      bu: "Neurosurgical",
      ASCCode: "NeuroC01",
    },
  ],

  footAndAnkle: [
    {
      partNumber: "PULCABLG & PULCABMD",
      product: "RFID Inventory Management Cabinet",
      category: "Pulse Intelligent Delivery Platform",
      qty: 0,
      bu: "",
      ASCCode: "",
      summaryLabel: "RFID Inventory Management Cabinet for F&A Forefoot Procedures",
    },
    {
      partNumber: "CB-1040-115",
      product: "CurveBeam AI HiRise WBCT",
      category: "Weight-bearing CT Scanner",
      qty: 0,
      bu: "",
      ASCCode: "",
      summaryLabel: "CurveBeam AI HiRise WBCT",
    },
  ],

  sterilization: [],
  tourniquet: [
    {
      partNumber: "5920-011-000",
      product: "SmartPump dual channel Tourniquet Pump",
      category: "Tourniquet system",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC06",
      summaryLabel: "SmartPump tourniquet system",
    },

    {
      partNumber: "5920-013-000",
      product: "SmartPump rolling stand",
      category: "Tourniquet system",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC06",
    },
  ],
  surgicalHelmets: [
    {
      partNumber: "0416-610-000",
      product: "T7 Surgical Helmet (Lighted)",
      category: "Surgical Helmets",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC07",
      summaryLabel: "T7 surgical helmet (Lighted)",
    },
    {
      partNumber: "0416-600-000",
      product: "T7 Surgical Helmet (Non-lighted)",
      category: "Surgical Helmets",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC07",
      summaryLabel: "T7 surgical helmet (Non-lighted)",
    },
    {
      partNumber: " 0408-655-000",
      product: "Flyte 120V charger ",
      category: "Surgical Helmets - Charger",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC08",
    },
    {
      partNumber: "0408-660-000",
      product: "Powerpack extended life (battery)",
      category: "Surgical Helmets - Battery",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC08",
    },
    {
      partNumber: "0400-204-000",
      product: "Wall Rack",
      category: "Surgical Helmets - Wall Rack",
      qty: 0,
      bu: "Orthopaedic Instruments",
      ASCCode: "OrthoC08",
      summaryLabel: "Surgical helmet wall rack",
    },
  ],
  sportMedicine: [
    {
      partNumber: "450000000",
      product: "CrossFlow Pump",
      category: "Arthroscopy capital",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC01",
      summaryLabel: "CrossFlow Pump",
    },

    {
      partNumber: "475100000",
      product: "CrossFire",
      category: "Arthroscopy capital",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC01",
      summaryLabel: "CrossFire",
    },

    {
      partNumber: "475000100",
      product: "CrossFire foot pedal",
      category: "Arthroscopy capital",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC01",
    },

    {
      partNumber: "375708500",
      product: "CrossFire handpiece",
      category: "Arthroscopy capital",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC01",
    },
    {
      partNumber: "272707000",
      product: "Cutter Cannula Set",
      category: "Arthroscopy capital",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC01",
    },
    {
      partNumber: "242200021",
      product: "InSpace balloon ",
      category: "Arthroscopy capital",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC01",
      summaryLabel: "Inspace Balloon",
    },
  ],
  sportInstrumentation: [
    {
      partNumber: "3910500743",
      product: "Champion shoulder instrumentation set",
      category: "Shoulder Trays/Instrumentation Package",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC02",
      summaryLabel: "Shoulder Trays/Instrumentation Package",
    },

    {
      partNumber: "3910900087",
      product: "Champion Suture Passer",
      category: "Suture Passer",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC02",
      summaryLabel: "Antegrade Suture Passer",
    },
  ],
  sportAccessories: [
    {
      partNumber: "3105400000",
      product: "Arm Positioner",
      category: "Adaptable Patient Positioner",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC10",
      summaryLabel: "Adaptable arm positioner",
    },

    {
      partNumber: "3105400030",
      product: "Beach Chair",
      category: "Adaptable Patient Positioner",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC11",
      summaryLabel: "Beach chair",
    },
  ],
  sportsKneeInstrumentation: [
    {
      partNumber: "TBD",
      product: "Knee Trays/Instrumentation Package",
      category: "Knee Trays / Instrumentation",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC05",
      summaryLabel: "Knee Trays/Instrumentation Package",
    },
  ],
  sportsHipInstrumentation: [
    {
      partNumber: "295720000",
      product: "Hip access kit and instrumentation kit",
      category: "Hip Trays / Instrumentation",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC07",
      summaryLabel: "Hip Trays/Instrumentation Package",
    },
  ],
  sportMedicineHipArthroscopy: [
    {
      partNumber: "3105000100",
      product: "Guardian Postless Distraction System",
      category: "Post-free hip distraction system",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC06",
      summaryLabel: "Pivot Guardian post-free distraction system",
    },

    {
      partNumber: "1030100",
      product: "HipCheck",
      category:
        "An intra-operative resection planning and execution tool that allows surgeons to measure and resect cam lesions to a desired alpha angle.",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC09",
      summaryLabel: "HipCheck - Patient-specific surgical planning",
    },
    {
      partNumber: "3105000320",
      product: "Pivot Guardian Direct",
      category:
        "Direct Anterior total hip arthroscopy attachment to Pivot Guardian distraction table",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC09",
    },
  ],
  sportMedicineFootAnkle: [
    {
      partNumber: "242100000",
      product: "Champion Small Joint Instrumentation Set",
      category: "Small joint manual instrument set (Conquest)",
      qty: 0,
      bu: "Sports Medicine",
      ASCCode: "SportsC08",
      summaryLabel: "Foot & Ankle Trays/Instrumentation Package",
    },
  ],
  entNavigation: [
    {
      partNumber: "8000010003",
      product: "Electromagnetic Navigation Unit",
      category: "ENT Navigation System ",
      qty: 1,
      bu: "Ear, Nose, and Throat",
      ASCCode: "ENTC01",
    },
    {
      partNumber: "8000010004",
      product: "Field Generator",
      category: "ENT Navigation System ",
      qty: 1,
      bu: "Ear, Nose, and Throat",
      ASCCode: "ENTC01",
    },
    {
      partNumber: "8000021002",
      product: "Scopis ENT Software with Target Guided Surgery",
      category: "ENT Navigation System ",
      qty: 1,
      bu: "Ear, Nose, and Throat",
      ASCCode: "ENTC01",
    },
  ],
  /* make addon */
  entDrills: [

    {

      partNumber: "5290-601-200",
      product: "Pello Microdebrider Handpiece",
      category: "ENT Drills, Irrigation Systems and Accessories",
      qty: 1,
      bu: "Ear, Nose, and Throat",
      ASCCode: "ENTC02",
      summaryLabel: "Pello Microdebrider Handpiece",
    },
    {

      partNumber: "LCP-AS-1001D",
      product: "Cliq Suction Pump",
      category: "ENT Drills, Irrigation Systems and Accessories",
      qty: 0,
      bu: "Ear, Nose, and Throat",
      ASCCode: "ENTC02",
      summaryLabel: "Cliq Suction Pump",
    }
  ],


  painManagement: [
    {
      partNumber: "8400-000-000",
      product: "MultiGen 2 radiofrequency generator",
      category: "Radiofrequency console",
      qty: 0,
      bu: "Interventional Spine",
      ASCCode: "IVSC01",
      summaryLabel: "MultiGen 2 radiofrequency generator",
    },

    {
      partNumber: "8400-825-010",
      product: "Venom cannula and electrode system",
      category: "Radiofrequency electrodes",
      qty: 0,
      bu: "Interventional Spine",
      ASCCode: "IVSC01",
    },

    {
      partNumber: "8400-800-000",
      product: "Splitter cable",
      category: "RF accessories",
      qty: 0,
      bu: "Interventional Spine",
      ASCCode: "IVSC01",
    },

    {
      partNumber: "0406-850-200",
      product: "Grounding pad cable",
      category: "RF accessories",
      qty: 0,
      bu: "Interventional Spine",
      ASCCode: "IVSC01",
    },
  ],
  videoEndoscopy: [
    {
      partNumber: "1688-010-000",
      product: "1688 Camera Control Unit (CCU)",
      category: "Camera box",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
      summaryLabel: "1688 AIM 4K Platform",
    },
    {
      partNumber: "220-230-300",
      product: "L11 LED Light Source with AIM",
      category: "Light source",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "240-200-100",
      product: "Pkg, Connected OR Hub Base System",
      category: "Capture device",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "240-080-230",
      product: "SDP1000 Digital Color Printer",
      category: "Printer",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "240-099-155",
      product: "Connected OR Cart",
      category: "Video cart",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "1688-210-122",
      product: "1688 Camera Head and Coupler Kit",
      category: "Camera head",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },
    {
      partNumber: "233-050-400",
      product:
        "FG, Safelight fiber optic cable with advanced imaging modality, 5 mm",
      category: "Light cord",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "502-445-030",
      product:
        "Precision 4K Autoclavable Eyepiece Arthroscopes, 4.0 mm, 30 degree",
      category: "Arthroscope",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "233-050-087",
      product: "Safelight AIM/Henke/Dyonics/Storz Scope Adapter",
      category: "Adapter",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "240-031-050",
      product: '4K 32" Surgical Display',
      category: "Monitor",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "240-099-110K",
      product: "Flat Panel Roll Stand Kit",
      category: "Roll stand",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC01",
    },

    {
      partNumber: "240-031-065",
      product: "Synk 4K Wireless Transmitter",
      category: "Wireless transmitter ",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC02",
    },

    {
      partNumber: "240-031-075",
      product: "Synk 4K Wireless Receiver",
      category: "Wireless receiver",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC02",
    },
  ],

  videoEndcscopyautoclavable: [
    {
      partNumber: "1688-010-000",
      product: "1688 Camera Control Unit (CCU)",
      category: "Camera box ",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
      summaryLabel: "Stryker 1688 4K Autoclavable Camera System",
    },
    {
      partNumber: "700-010-000",
      product: "Precision LED Light Source",
      category: "Light source",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "220-220-000",
      product: "Pkg, Connected OR Hub Base System",
      category: "Capture device",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "240-200-100",
      product: "SDP1000 Digital Color Printer",
      category: "Printer",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "240-080-230",
      product: "Connected OR Cart",
      category: "Video cart",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "240-099-155",
      product:
        "AIM 4K AC Camera Head and Coupler",
      category: "Camera head",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "700-410-122",
      product:
        "FG, SAFELIGHT FIBER OPTIC CABLE WITH ADVANCED IMAGING MODALITY, 5 MM",
      category: "Light cord",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "233-050-400",
      product:
        "Precision 4K Autoclavable Eyepiece Arthroscopes, 4.0 mm, 30 degree",
      category: "Arthroscope",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "502-445-030",
      product: "Safelight AIM/Henke/Dyonics/Storz Scope Adapter",
      category: "Adapter",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "233-050-087",
      product: '4K 32" OLED Surgical Display',
      category: "Monitor",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "240-031-300",
      product: "Flat Panel Roll Stand Kit",
      category: "Roll stand",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC04",
    },
    {
      partNumber: "240-099-110K",
      product: "Synk 4K Wireless Transmitter",
      category: "Wireless transmitter ",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC02",
    },
    {
      partNumber: "240-031-065",
      product: "Synk 4K Wireless Receiver",
      category: "Wireless receiver",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC02",
    },
  ],
  scopesOption1: [
    {
      partNumber: "620-050-000",
      product: "Pneumoclear Plus CO2 Conditioning Insufflator",
      category: "Insufflator",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC08",
      summaryLabel: "Pneumoclear Plus CO2 conditioning insufflator",
    },
    {
      partNumber: "TBD (customer preference)",
      product: "Precision Ideal Eyes Laparoscopes",
      category: "Laparoscope",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC06",
    },
    {
      partNumber: "TBD (customer preference)",
      product: "SPY Laparoscopes",
      category: "Laparoscope",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC07",
    },
  ],
  scopesOption2: [
    {
      partNumber: "TBD (customer preference)",
      product: "4.0mm Precision 4k Sinuscopes (0, 30, 45, 70 degree based on customer preference)",
      category: "Sinuscope",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC05",
    },
    {
      partNumber: "TBD (customer preference)",
      product: "Hydroflow Precision 4k Sinuscope Cleaning Sheaths (0, 30, 45, 70 degree based on customer preference)",
      category: "Cleaning Sheaths",
      qty: 0,
      bu: "Endoscopy",
      ASCCode: "EndoC05",
    },
  ],

  serviceContract: {
    partNumber: "N/A",
    product: "A maintenance and service plan that allows you to balance equipment uptime needs and your budget. Under a Protect service contract customers receive unlimited, comprehensive repairs through a standardized payment structure. A Prevent service contract also includes annual preventative maintenance visits for select equipment.",
    category: "Service Contract",
    qty: 1,
    bu: "OnSite",
    ASCCode: "service01",
    isNotEditable: true,
    summaryLabel: "Service Contract",
  },

  onSiteServicesProgram: {
    partNumber: "N/A",
    product:
      "A single OnSite Specialist is a subject matter expert that primarily focuses on the OR and maximizing technology pre, post, and intraoperatively. OnSite specialists save you time, money and resources by managing capital equipment and disposables while coordinating with the SPD so your nurses, technicians and  surgeons can increase patient focus and positive outcomes. ",
    category: "OnSite Specialist",
    qty: 1,
    bu: "OnSite",
    ASCCode: "OnSite01",
    isNotEditable: true,
    summaryLabel: "OnSite Specialist",
  },
};

export const NewAsessment = ({
  setModalClose,
  isOwnershipFull,
  history,
  createCustomerProfileAction,
  updateCustomreProfileAction,
  location,
}) => {
  // console.log("********* check whether editing or not", location.state);
  const { isEdit, initVal, page, type } = location.state;
  const [pagedIndex, setpagedIndex] = React.useState(page || 0);
  const [nextClicked, setnextClicked] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const modalDeleteAddControls = useIsOpenControls();
  const modalSaveAddControls = useIsOpenControls();
  const modalCompleteAddControls = useIsOpenControls();
  const modalSaveExitControls = useIsOpenControls();
  const modalFinalControls = useIsOpenControls();

  //click save&exit button
  const onClickGoBack = () => {
    setModalClose();
    history.goBack();
  };
  const dispatch = useDispatch();

  const handleSubmit = async (values: CustomerProfileConfig, functions) => {


    if (values.version && values.version == 1) {
      /* VERSION 1 OS OF 2025 */
      setnextClicked(false);
      functions.setTouched({});

      /* 
      CONCEPT:
      Replace legacy data with new data.
      Add new data to new data.
      */
      /* if (!values.version || values.version !== 1) {
        const propertiesThatNeedToBeReplaced = [
          "crashcartsDefibrillators",
          "tourniquet",
          "lobbyRoomFurniture",
          "patientBayFurniture",
          "patienWarning",
          "wasteManagements",
          "wasteManagementAddons",
          "safeAir",
          "transportChairs",
          "surgeonStools",
          "overnightBayRoomFurniture",
          "footAndAnkle",
          "saftySpongeSystem",
          "videoEndcscopyautoclavable",
          "videoEndoscopy",
          "powerTools",
  
          "surgicalHelmets",
          "sportMedicine",
          "sportInstrumentation",
          "sportAccessories",
          "sportsKneeInstrumentation",
          "sportsHipInstrumentation",
          "sportMedicineHipArthroscopy",
          "sportMedicineFootAnkle",
          "entNavigation",
          "entDrills",
          "painManagement",
          "scopesOption1",
          "scopesOption2",
          "serviceContract",
          "onSiteServicesProgram",
          "spineNavigations",
          "spineDrills",
          "version",
        ];
        propertiesThatNeedToBeReplaced.forEach((property) => {
          values[property] = initialValues[property];
        }
        );
      } */



      if (pagedIndex === 0) {

        if (type === ASSESSMENT_TYPE.MANUAL) {
          setLoading(true);
          let tmpConfig = { ...values };
          //Reset product quantity to 0
          Object.keys(tmpConfig).map((key, index) => {
            if (tmpConfig[key] instanceof Array) {
              tmpConfig[key].map((item, index) => {
                if (item.hasOwnProperty("qty")) {
                  tmpConfig[key][index].qty = 0;
                }
              });
            }
            if (tmpConfig[key].hasOwnProperty("qty")) {
              tmpConfig[key].qty = 0;
            }
          });
          const res = await createCustomerProfileAction({
            config: { ...tmpConfig, isManual: true },
            public_link: {
              lastViewed: "",
              shareLink: "",
              views: 0,
              is_active: false,
            },
          });
          setLoading(false);
          setModalClose();
          history.push(`/app/customer-profiles/detail/${res.value.id}`, {
            page: 1,
            isManual: true,
          });
        } else {
          setpagedIndex(pagedIndex + 1);
        }
      }
      if (pagedIndex === 1) {
        setpagedIndex(pagedIndex + 1);
      }
      if (pagedIndex === 2) {
        const totalORs =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[0].value) || 0
            : values.asc === "Existing ASC" 
              ? parseInt(values.facility_existing[0].value) || 0
              : values.asc === "Expansion / Construction of Existing ASC" || values.asc === "Existing"
                ? parseInt(values.facility_expanding[1].value) || 0
                : 0;
        // const totalPostOPRooms =
        //   values.asc === "De Novo / New Build ASC"
        //     ? (parseInt(values.facility_new[2].value) || 0) +
        //       (parseInt(values.facility_new[3].value) || 0)
        //     : values.asc === "Existing ASC"
        //     ? parseInt(values.facility_existing[4].value) || 0
        //     : values.asc === "Expansion / Construction of Existing ASC"
        //     ? parseInt(values.facility_expanding[7].value) || 0
        //     : 0;

        const totalLobbyRooms =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[4].value) || 0
            : values.asc === "Expansion / Construction of Existing ASC"
              ? parseInt(values.facility_expanding[9].value) || 0
              : 0;

        const totalOvernightRooms =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[6].value) || 0
            : values.asc === "Expansion / Construction of Existing ASC"
              ? parseInt(values.facility_expanding[12].value) || 0
              : 0;
        const totalPrePostOpRooms =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? (parseInt(values.facility_new[2].value) || 0) +
            (parseInt(values.facility_new[3].value) || 0)
            : values.asc === "Expansion / Construction of Existing ASC"
              ? parseInt(values.facility_expanding[7].value) || 0
              : 0;


        values.crashcartsDefibrillators[3].qty = totalORs;
        values.tourniquet[0].qty = totalORs;
        values.tourniquet[1].qty = totalORs;
        values.lobbyRoomFurniture[0].qty = totalPrePostOpRooms * 2;
        values.lobbyRoomFurniture[1].qty = totalLobbyRooms * 2;
        values.patientBayFurniture[0].qty = totalPrePostOpRooms * 1;
        values.patientBayFurniture[1].qty = totalPrePostOpRooms * 1;
        values.patienWarning.qty =
          Math.ceil(totalPrePostOpRooms / 2) + totalORs + 2;
        values.wasteManagements[0].qty = totalORs;
        values.wasteManagements[1].qty = Math.ceil(totalORs / 4);
        values.wasteManagements[2].qty = totalORs;
        values.transportChairs.qty = totalORs;
        values.surgeonStools.qty = totalORs;
        values.overnightBayRoomFurniture[0].qty = totalOvernightRooms;
        values.overnightBayRoomFurniture[1].qty = totalOvernightRooms;


        const hasFootAndAnkleSergions = values.specialties[4].value > 0;
        values.safeAir[0].qty = totalORs;
        values.safeAir[1].qty = totalORs;
        values.footAndAnkle[0].qty = hasFootAndAnkleSergions ? 1 : 0;
        values.footAndAnkle[1].qty = hasFootAndAnkleSergions ? 1 : 0;


        for (let index = 0; index < values.saftySpongeSystem.length; index++) {
          values.saftySpongeSystem[index].qty = totalORs;
        }
        for (let i = 0; i < values.videoEndcscopyautoclavable.length; i++) {
          if (
            ["Camera head", "Light cord", "Arthroscope", "Adapter"].some((el) =>
              values.videoEndcscopyautoclavable[i].category.includes(el)
            )
          ) {
            values.videoEndcscopyautoclavable[i].qty = totalORs * 3;
          } else if (
            values.videoEndcscopyautoclavable[i].category.includes("Monitor")
          ) {
            values.videoEndcscopyautoclavable[i].qty = totalORs * 2;
          } else {
            values.videoEndcscopyautoclavable[i].qty = totalORs;
          }
        }
        for (let i = 0; i < values.videoEndoscopy.length; i++) {
          if (
            ["Camera head", "Light cord", "Arthroscope", "Adapter"].some((el) =>
              values.videoEndoscopy[i].category.includes(el)
            )
          ) {
            values.videoEndoscopy[i].qty = totalORs * 3;
          } else if (values.videoEndoscopy[i].category.includes("Monitor")) {
            values.videoEndoscopy[i].qty = totalORs * 2;
          } else {
            values.videoEndoscopy[i].qty = totalORs;
          }
        }
        functions.setValues({ ...values });
        setpagedIndex(pagedIndex + 1);
      }

      if (pagedIndex === 3) {
        if (

          values.jpsub2 === "Yes" &&
          values.jpsub.filter((val) => !val.value).length === values.jpsub.length
        ) {
          functions.setErrors({ jpsub: "Need to select at least one item" });
          return;
        }
        const totalORs =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[0].value) || 0
            : values.asc === "Existing ASC" 
              ? parseInt(values.facility_existing[0].value) || 0
              : values.asc === "Expansion / Construction of Existing ASC" || values.asc === "Existing"
                ? parseInt(values.facility_expanding[1].value) || 0
                : 0;

        //power tool
        let times = totalORs < 5 ? 3 : totalORs < 9 ? 5 : 7;
        for (let i = 0; i < values.powerTools.length; i++) {
          if (i >= 0 && i <= 11) {
            //System 8 Power Tools Set
            //add Ons
            /*  if(values.jpsub1 && parseInt(values.jpsub1) > 0){
               if(i === 8){
                 //(3) Universal Battery Charger
                 values.powerTools[i].qty = times * 3;
               }else{
                 values.powerTools[i].qty = times;
               }
             } */
          } else if (i >= 12 && i <= 23) {

            //System 9 Power Tools Set
            //If Total Joints is selected
            if (values.jpsub1 && parseInt(values.jpsub1) > 0) {

              if (i === 19) {
                //(3) System 9 battery charger
                values.powerTools[i].qty = times * 3;
              } else {
                values.powerTools[i].qty = times;
              }
            }

          } else if (i >= 24 && i <= 37) {
            //TPX Logic
            if (values.specialties[4].value > 0 || values.specialties[5].value > 0) {
              if (i === 24 || i === 32) {
                /* TPX Cord & TPX handswitch */
                values.powerTools[i].qty = 2 * times;
              } else {
                values.powerTools[i].qty = times;
              }
            }
          } else if (i >= 37 && i <= 47) {

          } else if (i >= 48 && i <= 58) {
            //if sports medicine is selected
            if (values.specialties[0].value > 0) {

              if (i === 54) {
                //system 9 small battery pack
                values.powerTools[i].qty = 3 * times;
              } else {
                values.powerTools[i].qty = times;
              }
            }


          } else if (i >= 59 && i <= 68) {
            /* Pi Drive Plus Power Tools set */
            //If SPINE is selected
            if (values.specialties[3].value > 0) {
              if (i <= 65) {
                values.powerTools[i].qty = 2 * times;
              } else {
                values.powerTools[i].qty = times;
              }
            }
          }
        }


        values.surgicalHelmets[0].qty = parseInt(values.jpsub1);
        values.surgicalHelmets[1].qty = parseInt(values.jpsub1);
        values.surgicalHelmets[2].qty = 1;
        values.surgicalHelmets[3].qty = 1;
        values.surgicalHelmets[4].qty = 1;
        for (let j = 0; j < values.painManagement.length; j++) {
          if (
            values.specialties[6].value > 0 &&
            values.specialties[6].value < 4
          ) {
            if (j === 1) {
              values.painManagement[j].qty = 8;
            } else {
              values.painManagement[j].qty = 1;
            }
          }
          if (values.specialties[6].value > 3) {
            if (j === 1) {
              values.painManagement[j].qty = 16;
            } else {
              values.painManagement[j].qty = 2;
            }
          }
        }

        for (let j = 0; j < values.spineNavigations.length; j++) {
          if (values.sp1 === 'Imaging with navigation') {
            values.spineNavigations[j].qty = values.specialties[3].value;
          }

        }

        // for (let j = 0; j < values.breastRIsource.length - 1; j++) {
        //   values.breastRIsource[j].qty = 2;
        // }
        // values.breastRIsource[26].qty = 1;
        for (let i = 0; i < values.sportMedicine.length; i++) {
          if (i === values.sportMedicine.length - 3) {
            values.sportMedicine[i].qty = parseInt(values.smsub.smdrop[0]) * 2;
          } else {
            values.sportMedicine[i].qty = parseInt(values.smsub.smdrop[0]);
          }
        }
        for (let i = 0; i < values.sportInstrumentation.length; i++) {
          values.sportInstrumentation[i].qty = Math.ceil(
            (values.smsub.smary[2].value * parseInt(values.smsub.smdrop[1])) / 100
          );
        }

        values.sportAccessories[0].qty = Math.ceil(
          (values.smsub.smary[2].value * parseInt(values.smsub.smdrop[1]) * 0.3) /
          100
        );
        values.sportAccessories[1].qty = Math.ceil(
          (values.smsub.smary[2].value * parseInt(values.smsub.smdrop[1]) * 0.2) /
          100
        );
        for (let i = 0; i < values.sportsKneeInstrumentation.length; i++) {
          values.sportsKneeInstrumentation[i].qty = Math.ceil(
            (values.smsub.smary[1].value * parseInt(values.smsub.smdrop[1])) /
            100
          );
        }
        for (let i = 0; i < values.sportsHipInstrumentation.length; i++) {
          values.sportsHipInstrumentation[i].qty = Math.ceil(
            (values.smsub.smary[0].value * parseInt(values.smsub.smdrop[1])) / 100
          );
        }

        for (let i = 0; i < values.sportMedicineHipArthroscopy.length; i++) {
          values.sportMedicineHipArthroscopy[i].qty = parseInt(
            values.smsub.smdrop[2]
          );
        }


        //IF BOTH SPORTS MEDICINE AND JOINT REPLACEMENT SPECIALITIES SELECTED IN ASSESSMENT THEN = # OF Guardian Postless Distraction Systems on output.
        if (values.specialties[0].value > 0 && values.specialties[1].value > 0) {
          values.sportMedicineHipArthroscopy[2].qty = values.sportMedicineHipArthroscopy[0].qty;

        }







        for (let i = 0; i < values.sportMedicineFootAnkle.length; i++) {
          values.sportMedicineFootAnkle[i].qty = Math.ceil(
            (values.smsub.smary[3].value * parseInt(values.smsub.smdrop[1])) / 100
          );
        }
        if (values.specialties[10].value > 0) {
          values.scopesOption1[0].qty = 1;
          values.scopesOption1[1].qty = values.specialties[10].value * 4;
          values.scopesOption1[2].qty = values.specialties[10].value * 4;
        }
        if (values.specialties[8].value > 0) {
          values.scopesOption2[0].qty = values.specialties[8].value * 4;
          values.scopesOption2[1].qty = values.scopesOption2[0].qty;
          values.entDrills[0].qty = values.specialties[8].value;

        }

        functions.setValues({ ...values });
        // modalCompleteAddControls.handleOpen();
        setpagedIndex(pagedIndex + 1);
      }
      if (pagedIndex === 4) {
        modalFinalControls.handleOpen();
        //setpagedIndex(pagedIndex + 1);
      }



    } else {
      /* LEGACY AS OF JUNE 7th, 2024 */

      setnextClicked(false);
      functions.setTouched({});
      if (pagedIndex === 0) {

        if (type === ASSESSMENT_TYPE.MANUAL) {
          setLoading(true);
          let tmpConfig = { ...values };
          //Reset product quantity to 0
          Object.keys(tmpConfig).map((key, index) => {
            if (tmpConfig[key] instanceof Array) {
              tmpConfig[key].map((item, index) => {
                if (item.hasOwnProperty("qty")) {
                  tmpConfig[key][index].qty = 0;
                }
              });
            }
            if (tmpConfig[key].hasOwnProperty("qty")) {
              tmpConfig[key].qty = 0;
            }
          });
          const res = await createCustomerProfileAction({
            config: { ...tmpConfig, isManual: true },
            public_link: {
              lastViewed: "",
              shareLink: "",
              views: 0,
              is_active: false,
            },
          });
          setLoading(false);
          setModalClose();
          history.push(`/app/customer-profiles/detail/${res.value.id}`, {
            page: 1,
            isManual: true,
          });
        } else {
          setpagedIndex(pagedIndex + 1);
        }
      }
      if (pagedIndex === 1) {
        setpagedIndex(pagedIndex + 1);
      }
      if (pagedIndex === 2) {
        const totalORs =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[0].value) || 0
            : values.asc === "Existing ASC" 
              ? parseInt(values.facility_existing[0].value) || 0
              : values.asc === "Expansion / Construction of Existing ASC" || values.asc === "Existing"
                ? parseInt(values.facility_expanding[1].value) || 0
                : 0;
        // const totalPostOPRooms =
        //   values.asc === "De Novo / New Build ASC"
        //     ? (parseInt(values.facility_new[2].value) || 0) +
        //       (parseInt(values.facility_new[3].value) || 0)
        //     : values.asc === "Existing ASC"
        //     ? parseInt(values.facility_existing[4].value) || 0
        //     : values.asc === "Expansion / Construction of Existing ASC"
        //     ? parseInt(values.facility_expanding[7].value) || 0
        //     : 0;

        const totalLobbyRooms =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[4].value) || 0
            : values.asc === "Expansion / Construction of Existing ASC"
              ? parseInt(values.facility_expanding[9].value) || 0
              : 0;

        const totalOvernightRooms =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[6].value) || 0
            : values.asc === "Expansion / Construction of Existing ASC"
              ? parseInt(values.facility_expanding[12].value) || 0
              : 0;
        const totalPrePostOpRooms =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? (parseInt(values.facility_new[2].value) || 0) +
            (parseInt(values.facility_new[3].value) || 0)
            : values.asc === "Expansion / Construction of Existing ASC"
              ? parseInt(values.facility_expanding[7].value) || 0
              : 0;


        values.crashcartsDefibrillators[3].qty = totalORs;
        values.tourniquet[0].qty = totalORs;
        values.tourniquet[1].qty = totalORs;
        values.lobbyRoomFurniture[0].qty = totalPrePostOpRooms * 2;
        values.lobbyRoomFurniture[1].qty = totalLobbyRooms * 2;
        values.patientBayFurniture[0].qty = totalPrePostOpRooms * 1;
        values.patientBayFurniture[1].qty = totalPrePostOpRooms * 1;
        values.patienWarning.qty =
          Math.ceil(totalPrePostOpRooms / 2) + totalORs + 2;
        values.wasteManagements[0].qty = totalORs;
        values.wasteManagements[1].qty = Math.ceil(totalORs / 4);
        values.wasteManagements[2].qty = totalORs;
        values.transportChairs.qty = totalORs;
        values.surgeonStools.qty = totalORs;
        values.overnightBayRoomFurniture[0].qty = totalOvernightRooms;
        values.overnightBayRoomFurniture[1].qty = totalOvernightRooms;
        for (let index = 0; index < values.saftySpongeSystem.length; index++) {
          values.saftySpongeSystem[index].qty = totalORs;
        }
        for (let i = 0; i < values.videoEndcscopyautoclavable.length; i++) {
          if (
            ["Camera head", "Light cord", "Arthroscope", "Adapter"].some((el) =>
              values.videoEndcscopyautoclavable[i].category.includes(el)
            )
          ) {
            values.videoEndcscopyautoclavable[i].qty = totalORs * 3;
          } else if (
            values.videoEndcscopyautoclavable[i].category.includes("Monitor")
          ) {
            values.videoEndcscopyautoclavable[i].qty = totalORs * 2;
          } else {
            values.videoEndcscopyautoclavable[i].qty = totalORs;
          }
        }
        for (let i = 0; i < values.videoEndoscopy.length; i++) {
          if (
            ["Camera head", "Light cord", "Arthroscope", "Adapter"].some((el) =>
              values.videoEndoscopy[i].category.includes(el)
            )
          ) {
            values.videoEndoscopy[i].qty = totalORs * 3;
          } else if (values.videoEndoscopy[i].category.includes("Monitor")) {
            values.videoEndoscopy[i].qty = totalORs * 2;
          } else {
            values.videoEndoscopy[i].qty = totalORs;
          }
        }
        functions.setValues({ ...values });
        setpagedIndex(pagedIndex + 1);
      }

      if (pagedIndex === 3) {
        if (

          values.jpsub2 === "Yes" &&
          values.jpsub.filter((val) => !val.value).length === values.jpsub.length
        ) {
          functions.setErrors({ jpsub: "Need to select at least one item" });
          return;
        }
        const totalORs =
          values.asc === "De Novo / New Build ASC" || values.asc === "New Build"
            ? parseInt(values.facility_new[0].value) || 0
            : values.asc === "Existing ASC" 
              ? parseInt(values.facility_existing[0].value) || 0
              : values.asc === "Expansion / Construction of Existing ASC" || values.asc === "Existing"
                ? parseInt(values.facility_expanding[1].value) || 0
                : 0;

        //power tool
        let times = totalORs < 5 ? 3 : totalORs < 9 ? 5 : 7;
        for (let i = 0; i < values.powerTools.length; i++) {
          if (i >= 0 && i <= 11) {
            //System 8 Power Tools Set
            //add Ons
            /*  if(values.jpsub1 && parseInt(values.jpsub1) > 0){
               if(i === 8){
                 //(3) Universal Battery Charger
                 values.powerTools[i].qty = times * 3;
               }else{
                 values.powerTools[i].qty = times;
               }
             } */
          } else if (i >= 12 && i <= 23) {

            //System 9 Power Tools Set
            //If Total Joints is selected
            if (values.jpsub1 && parseInt(values.jpsub1) > 0) {

              if (i === 19) {
                //(3) System 9 battery charger
                values.powerTools[i].qty = times * 3;
              } else {
                values.powerTools[i].qty = times;
              }
            }

          } else if (i >= 24 && i <= 36) {
            //TPX Logic
            if (values.specialties[4].value > 0 || values.specialties[5].value > 0) {
              if (i === 24 || i === 32) {
                /* TPX Cord & TPX handswitch */
                values.powerTools[i].qty = 2 * times;
              } else {
                values.powerTools[i].qty = times;
              }
            }
          } else if (i >= 37 && i <= 47) {

            //System 8 Cordless Driver Power Tools set
            //Sports Medicine is selected
            //ADD ONS
            /*  if(values.specialties[0].value > 0){
               if(i === 43){
                 //system 8 small battery pack
                 values.powerTools[i].qty = 3 * times;
               }else{
                 values.powerTools[i].qty = times;
               }
             } */

          } else if (i >= 48 && i <= 58) {
            //if sports medicine is selected
            if (values.specialties[0].value > 0) {

              if (i === 54) {
                //system 9 small battery pack
                values.powerTools[i].qty = 3 * times;
              } else {
                values.powerTools[i].qty = times;
              }
            }


          } else if (i >= 59 && i <= 68) {
            /* Pi Drive Plus Power Tools set */
            //If SPINE is selected
            if (values.specialties[3].value > 0) {
              if (i <= 65) {
                values.powerTools[i].qty = 2 * times;
              } else {
                values.powerTools[i].qty = times;
              }
            }
          }

          /*  if (i === 7 || i === 31) {
             values.powerTools[i].qty = times * 3;
           } else if (i === 12 || i === 20) {
             values.powerTools[i].qty = times * 2;
           } else if (i < 36) {
             values.powerTools[i].qty = times;
           } else if (i < 43) {
             values.powerTools[i].qty = 2;
           } else {
             if(i === 54){
               values.powerTools[i].qty = 3;
             }else{
               values.powerTools[i].qty = 1;
             }
             
           } */
        }


        values.surgicalHelmets[0].qty = parseInt(values.jpsub1);
        values.surgicalHelmets[1].qty = parseInt(values.jpsub1);
        values.surgicalHelmets[2].qty = 1;
        values.surgicalHelmets[3].qty = 1;
        values.surgicalHelmets[4].qty = 1; //added new on v2.0
        // values.eyeStretchers.qty =
        //   values.asc === "De Novo / New Build ASC"
        //     ? parseInt(values.eyeNewfacility.value) * 4
        //     : values.asc === "Expansion / Construction of Existing ASC"
        //     ? parseInt(values.eyeExpandingfacility.value) * 4
        //     : 0;
        for (let j = 0; j < values.painManagement.length; j++) {
          if (
            values.specialties[6].value > 0 &&
            values.specialties[6].value < 4
          ) {
            if (j === 1) {
              values.painManagement[j].qty = 8;
            } else {
              values.painManagement[j].qty = 1;
            }
          }
          if (values.specialties[6].value > 3) {
            if (j === 1) {
              values.painManagement[j].qty = 16;
            } else {
              values.painManagement[j].qty = 2;
            }
          }
        }

        for (let j = 0; j < values.spineNavigations.length; j++) {
          values.spineNavigations[0].qty = values.specialties[3].value;
          if (j > 0 && j < 11) {
            values.spineNavigations[j].qty = values.specialties[3].value;
          }
          if (j > 10 && j < 12) {
            values.spineNavigations[j].qty = values.specialties[3].value;
          }
          if (j > 11 && j < 14) {
            values.spineNavigations[j].qty = values.specialties[3].value;
          }
        }

        // for (let j = 0; j < values.breastRIsource.length - 1; j++) {
        //   values.breastRIsource[j].qty = 2;
        // }
        // values.breastRIsource[26].qty = 1;
        for (let i = 0; i < values.sportMedicine.length; i++) {
          if (i === values.sportMedicine.length - 2) {
            values.sportMedicine[i].qty = parseInt(values.smsub.smdrop[0]) * 2;
          } else {
            values.sportMedicine[i].qty = parseInt(values.smsub.smdrop[0]);
          }
        }
        for (let i = 0; i < values.sportInstrumentation.length; i++) {
          values.sportInstrumentation[i].qty = Math.ceil(
            (values.smsub.smary[2].value * parseInt(values.smsub.smdrop[1])) / 100
          );
        }

        values.sportAccessories[0].qty = Math.ceil(
          (values.smsub.smary[2].value * parseInt(values.smsub.smdrop[1]) * 0.3) /
          100
        );
        values.sportAccessories[1].qty = Math.ceil(
          (values.smsub.smary[2].value * parseInt(values.smsub.smdrop[1]) * 0.2) /
          100
        );
        for (let i = 0; i < values.sportsKneeInstrumentation.length; i++) {
          values.sportsKneeInstrumentation[i].qty = Math.ceil(
            (values.smsub.smary[1].value * parseInt(values.smsub.smdrop[1])) /
            100
          );
          // if (i < 121) {
          //   values.sportsKneeInstrumentation[i].qty = Math.ceil(
          //     (values.smsub.smary[5].value *
          //       values.smsub.smary[1].value *
          //       parseInt(values.smsub.smdrop[1])) /
          //       10000
          //   );
          // } else {
          //   values.sportsKneeInstrumentation[i].qty = Math.ceil(
          //     (values.smsub.smary[1].value * parseInt(values.smsub.smdrop[1])) /
          //       100
          //   );
          // }
        }
        for (let i = 0; i < values.sportsHipInstrumentation.length; i++) {
          values.sportsHipInstrumentation[i].qty = Math.ceil(
            (values.smsub.smary[0].value * parseInt(values.smsub.smdrop[1])) / 100
          );
        }

        for (let i = 0; i < values.sportMedicineHipArthroscopy.length; i++) {
          values.sportMedicineHipArthroscopy[i].qty = parseInt(
            values.smsub.smdrop[2]
          );
        }


        //IF BOTH SPORTS MEDICINE AND JOINT REPLACEMENT SPECIALITIES SELECTED IN ASSESSMENT THEN = # OF Guardian Postless Distraction Systems on output.
        if (values.specialties[0].value > 0 && values.specialties[1].value > 0) {
          values.sportMedicineHipArthroscopy[2].qty = values.sportMedicineHipArthroscopy[0].qty;

        }







        for (let i = 0; i < values.sportMedicineFootAnkle.length; i++) {
          values.sportMedicineFootAnkle[i].qty = Math.ceil(
            (values.smsub.smary[3].value * parseInt(values.smsub.smdrop[1])) / 100
          );
        }
        if (values.specialties[10].value > 0) {
          values.scopesOption1[0].qty = 1;
          values.scopesOption1[1].qty = values.specialties[10].value * 4;
          values.scopesOption1[2].qty = values.specialties[10].value * 4;
        }
        if (values.specialties[8].value > 0) {
          values.scopesOption2[0].qty = values.specialties[8].value * 4;
          values.scopesOption2[1].qty = values.scopesOption2[0].qty;
          values.entDrills[0].qty = values.specialties[8].value;
          values.entManualIns[0].qty = 1;

        }

        functions.setValues({ ...values });
        // modalCompleteAddControls.handleOpen();
        setpagedIndex(pagedIndex + 1);
      }
      if (pagedIndex === 4) {
        modalFinalControls.handleOpen();
        //setpagedIndex(pagedIndex + 1);
      }

    }
  };


  return (
    <ContainerHorizontal className={cls.Wrapper}>
      <Formik
        initialValues={
          isEdit
            ? {
              ...initVal.config,
              isManual: type === ASSESSMENT_TYPE.MANUAL ? true : false,
              surgicalHelmets: [...initialValues.surgicalHelmets],
              scopesOption1: [...initialValues.scopesOption1],
            }
            : { ...initialValues, isManual: type === ASSESSMENT_TYPE.MANUAL ? true : false }
        }
        validationSchema={
          pagedIndex === 0
            ? validateCustomerInfo(type === ASSESSMENT_TYPE.MANUAL ? true : false,)
            : pagedIndex === 1
              ? validateOwnership
              : pagedIndex === 2
                ? validateFacility
                : pagedIndex === 3
                  ? validateSpecialty
                  : null
        }
        onSubmit={async (value, functions) => {
          await handleSubmit(value, functions);
        }}
      >
        {(formikProps) => {
          const {
            handleChange,
            handleSubmit,
            values,
            setValues,
            errors,
            touched,
            setTouched,
            setErrors,
          } = formikProps;

          return (
            <form onSubmit={handleSubmit} className={cls.form}>
              <AssessmentSavedModal
                {...modalSaveAddControls}
                onClickGoBack={onClickGoBack}
              />
              <AssessmentDeleteModal
                {...modalDeleteAddControls}
                onClickDelete={onClickGoBack}
              />
              <AssessmentSaveExit
                {...modalSaveExitControls}
                onClickSave={() => {
                  !isEdit
                    ? createCustomerProfileAction({
                      config: { ...values },
                      public_link: {
                        lastViewed: "",
                        shareLink: "",
                        views: 0,
                        is_active: false,
                      },
                    })
                    : updateCustomreProfileAction(initVal.id, {
                      config: { ...values },
                      public_link: { ...initVal.public_link },
                    });
                  onClickGoBack();
                }}
              />
              <AssessmentFinal
                {...modalFinalControls}
                onClickContinue={() => {
                  !isEdit
                    ? createCustomerProfileAction({
                      config: { ...values },
                      public_link: {
                        lastViewed: "",
                        shareLink: "",
                        views: 0,
                        is_active: false,
                      },
                    }).then((res) => {
                      setModalClose();
                      history.push(
                        `/app/customer-profiles/detail/${res.value.id}`
                      );
                    })
                    : updateCustomreProfileAction(initVal.id, {
                      config: { ...values },
                      public_link: { ...initVal.public_link },
                    }).then((res) => {
                      setModalClose();
                      history.push(
                        `/app/customer-profiles/detail/${res.value.id}`
                      );
                    });
                }}
                onClickStartNew={() => {
                  !isEdit
                    ? createCustomerProfileAction({
                      config: { ...values },
                      public_link: {
                        lastViewed: "",
                        shareLink: "",
                        views: 0,
                        is_active: false,
                      },
                    }).then(() => {
                      modalFinalControls.handleClose();
                      setModalClose();
                      setpagedIndex(0);
                      setValues(initialValues);
                    })
                    : updateCustomreProfileAction(initVal.id, {
                      config: { ...values },
                      public_link: { ...initVal.public_link },
                    }).then(() => {
                      modalFinalControls.handleClose();
                      setModalClose();
                      setpagedIndex(0);
                      setValues(initialValues);
                    });
                }}
              />
              <TopBar
                isLoading={loading}
                isActiveSaveButton={values.account_name.length > 0}
                setModalClose={setModalClose}
                pagedIndex={pagedIndex}
                onClickBack={() => {
                  setpagedIndex(pagedIndex - 1);
                }}
                onClickDelete={() => {
                  if (values.account_name.length > 0) {
                    modalDeleteAddControls.handleOpen();
                  } else {
                    onClickGoBack();
                  }
                }}
                onClickSave={() => {
                  !isEdit
                    ? createCustomerProfileAction({
                      config: { ...values },
                      public_link: {
                        lastViewed: "",
                        shareLink: "",
                        views: 0,
                        is_active: false,
                      },
                    })
                    : updateCustomreProfileAction(initVal.id, {
                      config: { ...values },
                      public_link: { ...initVal.public_link },
                    });
                  modalSaveAddControls.handleOpen();
                }}
                onClickSaveModal={modalSaveExitControls.handleOpen}
                submitToggle={() => {
                  setnextClicked(true)
                }}
                //tony is here
                isContinuing={isEdit && initVal.config.isManual ? false : true}
              />
              <div className={cls.container}>
                {pagedIndex === 0 && <CustomerInfo {...formikProps} />}
                {pagedIndex === 1 && (
                  <OwnerShip {...formikProps} nextClicked={nextClicked} />
                )}
                {pagedIndex === 2 && (
                  <FacilityInfo {...formikProps} nextClicked={nextClicked} />
                )}
                {pagedIndex === 3 && (
                  <Specialties
                    {...formikProps}
                    // values={values}
                    // handleChange={handleChange}
                    // setValues={setValues}
                    // errors={errors}
                    // touched={touched}
                    nextClicked={nextClicked}
                  />
                )}
                {pagedIndex === 4 && (
                  <Communications {...formikProps} nextClicked={nextClicked} />
                )}
                {/*  {pagedIndex === 5 && (
                  <Acutecare {...formikProps} nextClicked={nextClicked} />
                )} */}
              </div>
            </form>
          );
        }}
      </Formik>
    </ContainerHorizontal>
  );
};
export default connect(
  (store: AppState) => ({
    isModalOpen: store.app.isModalOpen,
    isOwnershipFull: store.app.isOwnershipFull,
  }),
  {
    setModalClose: appActions.setModalClose,
    createCustomerProfileAction: createCustomerProfileAction,
    updateCustomreProfileAction: updateCustomreProfileAction,
  }
)(NewAsessment);
